var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"uppyDashboard"}}),_c('v-btn',{staticClass:"button d-none d-sm-flex",attrs:{"text":""},on:{"click":_vm.openUppy}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }